module.exports = __webpack_public_path__ + "img/SES_205288808.2d7746c0.jpg";